<div class="row justify-content-between align-items-center">
  <div class="col-auto">
    <bitf-mat-breadcrumbs [breadcrumbs]="fsStore.breadcrumbs"
      (breadcrumbClick)="onBreadcrumbClick($event)"
      [style.visibility]="isFullTextSearch ? 'hidden' : 'visible'"></bitf-mat-breadcrumbs>
  </div>

  <div class="ml-auto col-auto row align-items-center"
    *ngIf="isLoading">
    <mat-progress-spinner mode="indeterminate"
      diameter="20"></mat-progress-spinner>
    <span class="col-auto">{{'BITF.LABEL.LOADING' | translate}}</span>
  </div>
  <!-- <div>
    <mat-button-toggle-group appearance="standard"
      name="viewMode"
      (change)="onViewModeChange($event)"
      value="list">
      <mat-button-toggle value="list">
        <mat-icon>view_list</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="card">
        <mat-icon>view_module</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div> -->
</div>

<div *ngIf="itemLayout === EFsViewMode.LIST">
  <div class="row mx-auto align-items-center sort-bar">
    <div class="col-1">
      {{'COMMON.LABEL.CONTENT_TYPE' | translate}}
      <!-- <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_CONTENT_TYPE"
        [option]="orderByOptions.contentType" *ngIf="!isFullTextSearch"></bitf-mat-sort> -->
    </div>

    <div class="col-8"
      *ngIf="fsStore.configuration?.listColumns?.name"
      [ngClass]="fsStore.configuration?.listColumns?.name">
      <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_NAME"
        [option]="orderByOptions.name"
        *ngIf="!isFullTextSearch && !fsStore.configuration?.hideSorting"></bitf-mat-sort>
      <span
        *ngIf="isFullTextSearch || fsStore.configuration?.hideSorting">{{orderByOptions.name.label}}</span>
    </div>

    <div class="col-3"
      *ngIf="fsStore.configuration?.listColumns?.createdBy"
      [ngClass]="fsStore.configuration?.listColumns?.createdBy">
      <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_CREATED_BY"
        [option]="orderByOptions.createdBy"
        *ngIf="!isFullTextSearch && !fsStore.configuration?.hideSorting"></bitf-mat-sort>
      <span
        *ngIf="isFullTextSearch || fsStore.configuration?.hideSorting">{{orderByOptions.createdBy.label}}</span>
    </div>

    <div class="col-3"
      *ngIf="fsStore.configuration?.listColumns?.modifiedBy"
      [ngClass]="fsStore.configuration?.listColumns?.modifiedBy">
      <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED_BY"
        [option]="orderByOptions.modifiedBy"
        *ngIf="!isFullTextSearch && !fsStore.configuration?.hideSorting"></bitf-mat-sort>
      <span
        *ngIf="isFullTextSearch || fsStore.configuration?.hideSorting">{{orderByOptions.modifiedBy.label}}</span>
    </div>

    <div class="col-2"
      *ngIf="fsStore.configuration?.listColumns?.created"
      [ngClass]="fsStore.configuration?.listColumns?.created">
      <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_CREATED"
        [option]="orderByOptions.created"
        *ngIf="!isFullTextSearch && !fsStore.configuration?.hideSorting"></bitf-mat-sort>
      <span
        *ngIf="isFullTextSearch || fsStore.configuration?.hideSorting">{{orderByOptions.created.label}}</span>
    </div>

    <div class="col-2"
      *ngIf="fsStore.configuration?.listColumns?.modified"
      [ngClass]="fsStore.configuration?.listColumns?.modified">
      <bitf-mat-sort [apiCallStateName]="apiCallStateName"
        [apiRequestPartKey]="EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED"
        [option]="orderByOptions.modified"
        *ngIf="!isFullTextSearch && !fsStore.configuration?.hideSorting"></bitf-mat-sort>
      <span
        *ngIf="isFullTextSearch || fsStore.configuration?.hideSorting">{{orderByOptions.modified.label}}</span>
    </div>

    <div class="col-3"
      *ngIf="fsStore.configuration?.listColumns?.tags"
      [ngClass]="fsStore.configuration?.listColumns?.tags">
      <ng-container
        *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
        <span *ngIf="!isFullTextSearch || fsStore.configuration?.hideSorting">
          {{'COMMON.LABEL.TAGS' | translate}}
        </span></ng-container>
    </div>

    <div class="col-1"
      *ngIf="fsStore.configuration?.listColumns?.actions"
      [ngClass]="fsStore.configuration?.listColumns?.actions">

    </div>
  </div>

  <div class="mt-2">
    <mat-divider></mat-divider>
  </div>

  <div class="row align-content-center justify-content-center mt-5"
    *ngIf="fsItems.length === 0 && !isLoading">
    <prada-no-data message="{{'COMMON.LABEL.NO_FILE_FOUND' | translate}}"></prada-no-data>
  </div>

  <cdk-virtual-scroll-viewport itemSize="50"
    *ngIf="isVirtualScrollVisible"
    (scrolledIndexChange)="nextBatch()"
    [ngStyle]="virtualScrollStyle"
    [ngClass]="{'scrollbar-visible': fsStore.configuration?.alwaysShowScrollbar, 'full-height': !this.fsStore.configuration?.numberOfRows}">
    <prada-fs-list-item *cdkVirtualFor="let fsItem of fsItems; trackBy: trackByFn"
      (fsItemClick)="onFsFolderItemClick(fsItem)"
      [fsItem]="fsItem"
      [fsStore]="fsStore"
      (fsItemActionClick)="onFsItemActionClick($event)"></prada-fs-list-item>
  </cdk-virtual-scroll-viewport>

</div>